import { FooterLinkSection } from 'server/config-cache/types';

/**
 * Helper to get unique key for a footer link section for use in mapping over sections
 * in Footer component rendering logic.
 *
 * Includes fallbacks to deal with possibly undefined values, ultimately falling back to a provided
 * index val. While using index as key is bad practice, this backoff should really never
 * be hit, and even if so, these sections are  static, so its perfectly safe here.
 */
export const getKeyFromLinkSection = (
  linkSection: FooterLinkSection,
  idx: number,
): string => {
  const { header, links } = linkSection;
  if (header) {
    return header;
  }
  if (links?.length) {
    return `${links[0].url}-${links[0].displayText}`;
  }
  return `${idx}`;
};

export const parsePhoneToLink = (phoneString: string): string => {
  return 'tel:' + phoneString.replace(/[^\d]/g, ''); //removes all symbols but numbers, and replaces with empty string
};
export const parseEmailToLink = (emailString: string): string => {
  return 'mailTo:' + emailString;
};
